module.exports = __webpack_public_path__ + "media/newstyle/images/icon-lp-1-25edab195faf5baee11730d6b6b4bb65.svg";